import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {
  userData,
  userDetail,
} from "../app/modules/ECommerce/_redux/user/userReducer";
import { roleData } from "../app/modules/ECommerce/_redux/user/userReducer";
import {
  menuData,
  treeData,
  filterDataMenu,
} from "../app/modules/ECommerce/_redux/menu/menuReducer";
import {
  settingData,
  getSettingData,
} from "../app/modules/ECommerce/_redux/setting/settingReducer";
import { paramData } from "../app/modules/ECommerce/_redux/param/paramReducer";
import { paramGroupData } from "../app/modules/ECommerce/_redux/param-group/paramGroupReducer";
import { apilogData } from "../app/modules/ECommerce/_redux/apilog/apilogReducer";
import { emaillogData } from "../app/modules/ECommerce/_redux/emaillog/emaillogReducer";
import { emailtplData } from "../app/modules/ECommerce/_redux/emailtpl/emailtplReducer";
import { plantData } from "../app/modules/ECommerce/_redux/plant/plantReducer";
import { kcabangData } from "../app/modules/ECommerce/_redux/kcabang/kcabangReducer";
import { crprgpData } from "../app/modules/ECommerce/_redux/crprgp/crprgpReducer";
import { customerData } from "../app/modules/ECommerce/_redux/customer/customerReducer";
import { materialData } from "../app/modules/ECommerce/_redux/material/materialReducer";
import { clientUserData } from "../app/modules/ECommerce/_redux/client-user/clientUserReducer";
import { rdetailData } from "../app/modules/ECommerce/_redux/rdetail/rdetailReducer";
import { rhheaderData } from "../app/modules/ECommerce/_redux/rh-header/rhheaderReducer";
import { rhdetailData } from "../app/modules/ECommerce/_redux/rh-detail/rhdetailReducer";
import { uomData } from "../app/modules/ECommerce/_redux/uom/uomReducer";
import { sapInvoiceOldData } from "../app/modules/ECommerce/_redux/sap-Invoice-old/sapInvoiceOldReducer";
import { sapTaxOldData } from "../app/modules/ECommerce/_redux/sap-tax-old/sapTaxOldReducer";
import {
  withoutRtvData,
  filterDataRtv,
  nonMTKADetails,
  nonMTKADetailsTemp,
  nonMTKAFrom,
} from "../app/modules/ECommerce/_redux/without-rtv/withoutRtvReducer";
import {
  filterDataNonRef,
  nonRefDetails,
  nonRefDetailsTemp,
  nonRefFrom,
} from "../app/modules/ECommerce/_redux/non-reference/nonRefReducer";
import {
  fssData,
  filterDataFss,
  approvalFssDetail,
  valueFssData,
} from "../app/modules/ECommerce/_redux/fss-asm-bm/fssReducer";
import {
  qahoData,
  filterDataQaho,
  approvalQahoDetail,
  valueQahoData,
} from "../app/modules/ECommerce/_redux/qaho/qahoReducer";
import {
  brqaData,
  filterDataBrqa,
  approvalBrqaDetail,
  valueBrqaData,
} from "../app/modules/ECommerce/_redux/brqa/brqaReducer";
import {
  clientData,
  filterDataClient,
  approvalClientDetail,
  valueClientData,
} from "../app/modules/ECommerce/_redux/client/clientReducer";
import {
  reportHeaderData,
  draftHeaderData,
  reportHeaderDetailData,
  filterDataReportHeader,
} from "../app/modules/ECommerce/_redux/report-header/reportHeaderReducer";
import {
  reportDetailData,
  valueReportDetailData,
  filterDataReportDetail,
} from "../app/modules/ECommerce/_redux/report-detail/reportDetailReducer";

import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

// new reducer slice using redux toolkit
import apiLogReducer from "../app/pages/administrator/api-log/apiLogSlice";
import emailTemplateReducer from "../app/pages/administrator/email-template/emailTemplateSlice";
import emailLogReducer from "../app/pages/administrator/email-log/emailLogSlice";
import rdetailReducer from "../app/pages/master/r-detail/rdetailSlice";
import rhheaderReducer from "../app/pages/master/rh-header/rhheaderSlice";
import rhdetailReducer from "../app/pages/master/rh-detail/rhdetailSlice";
import kcabangReducer from "../app/pages/master/k-cabang/kcabangSlice";
import uomReducer from "../app/pages/master/alt-uom/uomSlice";
import plantReducer from "../app/pages/master/plant/plantSlice";
import crprgpReducer from "../app/pages/master/crprgp/crprgpSlice";
import customerReducer from "../app/pages/master/customer/customerSlice";
import invoiceOldReducer from "../app/pages/master/sap-invoice-old/invoiceOldSlice";
import taxOldReducer from "../app/pages/master/sap-tax-old/taxOldSlice";
import reportHeaderReducer from "../app/pages/report-return/report-header/reportHeaderSlice";
import reportDetailReducer from "../app/pages/report-return/report-detail/reportDetailSlice";
import qahoReducer from "../app/pages/qaho/qahoSlice";
import brqaReducer from "../app/pages/brqa/brqaSlice";
import clientReducer from "../app/pages/client/clientSlice";
import fssReducer from "../app/pages/fss-asm-bm/fssSlice";
import warehouseReducer from "../app/pages/chief-warehouse/warehouseSlice";
import deliveryReducer from "../app/pages/chief-delivery/deliverySlice";
import paramGroupReducer from "../app/pages/administrator/parameter-group/paramGroupSlice";
import parameterReducer from "../app/pages/administrator/bussiness-parameter/parameterSlice";
import generalSettingReducer from "../app/pages/administrator/general-setting/generalSettingSlice";
import rejectReducer from "../app/pages/reject-return/rejectSlice";
import withrtvReducer from "../app/pages/new-return/with-rtv/withrtvSlice";
import nonRefReducer from "../app/pages/new-return/without-rtv/non-reference/nonRefSlice";
import withoutRtvReducer from "../app/pages/new-return/without-rtv/reference/withoutRtvSlice";
import dashboardReducer from "../app/pages/dashboard/dashboardSlice";
import roleReducer from "../app/pages/administrator/user/roles/roleSlice";
import userReducer from "../app/pages/administrator/master-user/userSlice"
import approvalReducer from "../app/pages/report-return/approval-changes/approvalSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  userData,
  userDetail,
  roleData,
  menuData,
  treeData,
  filterDataMenu,
  settingData,
  getSettingData,
  paramData,
  paramGroupData,
  apilogData,
  emaillogData,
  emailtplData,
  plantData,
  kcabangData,
  crprgpData,
  customerData,
  materialData,
  clientUserData,
  rdetailData,
  rhheaderData,
  rhdetailData,
  uomData,
  sapInvoiceOldData,
  sapTaxOldData,
  withoutRtvData,
  filterDataRtv,
  nonMTKADetails,
  nonMTKADetailsTemp,
  fssData,
  filterDataFss,
  approvalFssDetail,
  valueFssData,
  clientData,
  filterDataClient,
  approvalClientDetail,
  brqaData,
  filterDataBrqa,
  valueBrqaData,
  qahoData,
  filterDataQaho,
  valueQahoData,
  valueClientData,
  approvalQahoDetail,
  approvalBrqaDetail,
  reportHeaderData,
  draftHeaderData,
  filterDataReportHeader,
  reportHeaderDetailData,
  reportDetailData,
  valueReportDetailData,
  filterDataReportDetail,
  filterDataNonRef,
  nonRefDetails,
  nonRefDetailsTemp,
  nonRefFrom,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  // new reducer slice using redux toolkit
  apiLog: apiLogReducer,
  emailTemplate: emailTemplateReducer,
  emailLog: emailLogReducer,
  generalSetting: generalSettingReducer,
  rdetail: rdetailReducer,
  rhheader: rhheaderReducer,
  rhdetail: rhdetailReducer,
  kcabang: kcabangReducer,
  uom: uomReducer,
  plant: plantReducer,
  crprgp: crprgpReducer,
  customer: customerReducer,
  invoiceOld: invoiceOldReducer,
  taxOld: taxOldReducer,
  reportHeader: reportHeaderReducer,
  reportDetail: reportDetailReducer,
  qaho: qahoReducer,
  brqa: brqaReducer,
  client: clientReducer,
  fss: fssReducer,
  delivery: deliveryReducer,
  warehouse: warehouseReducer,
  paramGroup: paramGroupReducer,
  parameter: parameterReducer,
  reject: rejectReducer,
  withrtv: withrtvReducer,
  nonRef: nonRefReducer,
  dashboard: dashboardReducer,
  role: roleReducer,
  withoutRtv: withoutRtvReducer,
  user: userReducer,
  approval: approvalReducer,
  nonMTKAFrom,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
